import templateOnly from "@ember/component/template-only";
import { setComponentTemplate } from "@ember/component";
import { precompileTemplate } from "@ember/template-compilation";
const SelectedItem = setComponentTemplate(precompileTemplate(`
  Change Card
`, {
  strictMode: true
}), templateOnly("index", "SelectedItem"));
export default SelectedItem;